import { css } from '@emotion/core';
import { gray5, lightCyan } from 'styles/global_defaults/colors';
import { doubleSpacing, halfSpacing, quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';

// SuggestActivities styles start
export const lhsStyles = css`
  &.generate-box {
    border: double 2px transparent;
    border-radius: ${halfSpacing}px;
    margin: -2px;
    border-image-slice: 2;
    background-color: ${lightCyan};
    background-image: linear-gradient(${lightCyan}, ${lightCyan}),
      linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    gap: ${standardSpacing}px;
  }
`;

export const lhsModalStyles = css`
  .modal-page {
    max-width: 1040px;
    overflow-y: auto;
    right: 0;
    left: 0;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const lhsCommonStyles = css`
  .text-lg-bold {
    font-size: 16px;
    line-height: 25px;
    font-weight: 700;
  }
`;
// SuggestActivities styles end

export const modalContentStyles = css`
  .gradient-top {
    position: sticky;
    height: ${quarterSpacing}px;
    background: linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
    top: 0;
  }
`;

export const suggestedActivitiesStyles = css`
  gap: ${doubleSpacing}px;

  .list-item {
    border-top: 1px solid ${gray5};
  }

  .list-item:last-child {
    border-bottom: 1px solid ${gray5};
  }
`;
